import { cn } from '@utils';
import * as React from 'react'
import type { TypographyProps } from '../types/typography.types';

const Body1AccentedTypography = React.forwardRef<HTMLParagraphElement, TypographyProps>(
	({ className, children, ...props }, ref) => (
		<p
			ref={ref}
			className={cn('scroll-m-20 text-base font-semibold truncate', className)}
			data-aid="body1-accented-typography"
			{...props}
		>
			{children}
		</p>
	)
);

Body1AccentedTypography.displayName = 'Body1AccentedTypography';

export default Body1AccentedTypography;
